// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + "8b94c2b6e4bb3fa168aa" + ".css";
};